import { render, staticRenderFns } from "./AppLayoutPlans.vue?vue&type=template&id=fc50f10c&"
import script from "./AppLayoutPlans.vue?vue&type=script&lang=js&"
export * from "./AppLayoutPlans.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutPlans.vue?vue&type=style&index=0&id=fc50f10c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports